const tooltip = {

    //DEALER SERVICE
    'dealerService': {
        //Dealer Service Overview
        'serviceOverview': 'Merupakan gambaran jumlah servis yang terjadi pada seluruh dealer',
        'unitEntryAnalysis': 'Analisa jumlah kendaraan yang melakukan servis diseluruh dealer',
        'unitEntryByRegion': 'Jumlah kendaraan yang melakukan servis berdasarkan wilayah kerja',
        'unitEntryByModel': 'Jumlah kendaraan yang melakukan servis berdasarkan field Model/Type kendaraan di Region dan Dealer terpilih',
        'unitEntryByProductionYear': 'Jumlah kendaraan yang melakukan servis berdasarkan tahun pembuatan',
        'unitEntryByColor': 'Jumlah kendaraan servis berdasarkan warna kendaraan',

        //Dealer Service Operation
        'serviceOperation': 'Gambaran layan servis yang tersedia',
        'unitEntryByPkb': 'Jumlah yang melakukan servis berdasarkan PKB Type',
        'pkbDetails': 'Detail PKB',
        'unitEntryByCustomerLocation': 'Jumlah yang melakukan servis berdasarkan lokasi customer',
        'unitEntryBodyRepairByInsurance': 'Jumlah kendaraan yang melakukan servis berdasarkan asuransi',
        'unitEntryByDamageType': 'Jumlah kendaraan yang melakukan servis berdasarkan jenis kerusakan',
        'qrRegisterAndPlacement': 'Jumlah kendaraan yang melakukan mapping'
    }

}

export default tooltip;